import { Component, OnInit, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "no-data",
  templateUrl: "./no-data.component.html",
  styleUrls: ["./no-data.component.scss"],
})
export class NoDataComponent implements OnInit {
  @Input() message: string;
  @Input() showModalCloseBtn: boolean;
  image: string;

  constructor(private modalController: ModalController) {
    this.image = "../../../../assets/images/no_data.svg";
    if (!this.message) {
      this.message = "No Results Found!";
    }
  }

  ngOnInit() {}

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.modalController.dismiss();
  }
}
